const PLACEMENTS = {
    OVERLAY: 'OVERLAY',
    ABOVE: 'ABOVE',
    BELOW: 'BELOW',
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
    ALTERNATE_HORIZONTALLY: 'ALTERNATE_HORIZONTALLY',
    ALTERNATE_VERTICALLY: 'ALTERNATE_VERTICALLY',
};
export const hasHoverPlacement = (placement) => String(placement).includes(PLACEMENTS.OVERLAY);
export const hasExternalAbovePlacement = (placement, idx) => String(placement).includes(PLACEMENTS.ABOVE) ||
    (idx % 2 === 0 && String(placement).includes(PLACEMENTS.ALTERNATE_VERTICALLY));
export const hasExternalBelowPlacement = (placement, idx) => String(placement).includes(PLACEMENTS.BELOW) ||
    (idx % 2 === 1 && String(placement).includes(PLACEMENTS.ALTERNATE_VERTICALLY));
export const hasExternalRightPlacement = (placement, idx) => String(placement).includes(PLACEMENTS.RIGHT) ||
    (idx % 2 === 0 && String(placement).includes(PLACEMENTS.ALTERNATE_HORIZONTALLY));
export const hasExternalLeftPlacement = (placement, idx) => String(placement).includes(PLACEMENTS.LEFT) ||
    (idx % 2 === 1 && String(placement).includes(PLACEMENTS.ALTERNATE_HORIZONTALLY));
export const hasExternalVerticalPlacement = (placement) => hasExternalAbovePlacement(placement, 0) || hasExternalBelowPlacement(placement, 1);
export const hasExternalHorizontalPlacement = (placement) => hasExternalRightPlacement(placement, 0) || hasExternalLeftPlacement(placement, 1);
export const isExternalVerticalPlacement = (placement) => hasExternalVerticalPlacement(placement) &&
    !hasExternalHorizontalPlacement(placement) &&
    !hasHoverPlacement(placement);
export const isExternalHorizontalPlacement = (placement) => hasExternalHorizontalPlacement(placement) &&
    !hasExternalVerticalPlacement(placement) &&
    !hasHoverPlacement(placement);
export const isExternalAbovePlacement = (placement) => String(placement) === PLACEMENTS.ABOVE;
export const isExternalBelowPlacement = (placement) => String(placement) === PLACEMENTS.BELOW;
export const isExternalAboveOrBelowSinglePlacement = (placement) => isExternalAbovePlacement(placement) || isExternalBelowPlacement(placement);
export const isHoverPlacement = (placement) => String(placement) === PLACEMENTS.OVERLAY;
export const isExternalRightPlacement = (placement) => String(placement) === PLACEMENTS.RIGHT;
export const isExternalLeftPlacement = (placement) => String(placement) === PLACEMENTS.LEFT;
export const isConstantVerticalPlacement = (placement) => {
    const placementArray = placement.split(',');
    const firstPlacement = placementArray.shift();
    return (isExternalAboveOrBelowSinglePlacement(firstPlacement) &&
        placementArray.every((placement) => placement === firstPlacement));
};
export default PLACEMENTS;
//# sourceMappingURL=layoutParams_info_placement.js.map